import { useTheme } from '@emotion/react'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary, Box
} from '@mui/material'
import { StatiPratica } from 'enums/stati-pratica'
import { useEffect, useState } from 'react'
import { isValidUser, isValidUserInputMultipleFunctions } from 'OnlyWithFunctions'
import CustomModal from 'UI/CustomModal'
import { StyledButton } from 'UI/StyledButton'
import { closeAdvMr } from 'services/closeAdvMr'
import { closePratica } from 'services/closePratica'
import { saveEsitoAdv } from 'services/saveEsitoAdv'
import RenderComponente from './sezioni/RenderComponente'
import Supporto from './sezioni/Supporto'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import { Roles } from 'enums/roles'
import { listaStatiRichiestaSupportoSezionGialla, listaRuoliRichiestaSupportoSezionGialla, listaRuoliRispostaSupportoSezionGialla }
  from "enums/constants-richieste-supporto"

export function SezioneGialla({ esitoAdv, tipoInserimento, statoPratica, assegnatario, idPratica, abilitaChiuso, refecthPratica, handleReloadDettaglio, showSupportoConsulenziale }) {
  const theme = useTheme()

  const [rootComponent, setRootComponent] = useState(esitoAdv)
  const [expanded, setExpanded] = useState(false)
  const [open, setOpen] = useState(false)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [saveRequired, setSaveRequired] = useState(false)
  const [infoMessage, setInfoMessage] = useState('')
  const [showSupporto, setShowSupporto] = useState(false)
  const [rispostaSupporto, setRispostaSupporto] = useState(null)
  const disableChoice = (statoPratica === 'Da Approvare' || statoPratica === 'Chiusa') || assegnatario !== JSON.parse(localStorage.getItem('user'))
  const showButton = !disableChoice
  const showButtonSupportoCons = showSupportoConsulenziale && statoPratica !== 'Chiusa'
  const [openModal, setOpenModal] = useState(false);
  const [isComponenteInalzaRischioSelezionato, setIsComponenteInalzaRischioSelezionato] = useState(false)
  const updateComponenteSelection = (componente, isSelected, value) => {
    const updateRecursively = (comp) => {
      if (comp === componente) {
        comp.isSelected = isSelected
        if (comp.tipoComponente === 'TEXTFIELD') {
          comp.value = value
        }
        setSaveRequired(true)
      }
      if (comp.children) {
        comp.children.forEach(child => updateRecursively(child))
      }
    }
    const updatedRoot = { ...rootComponent }
    updateRecursively(updatedRoot)
    setRootComponent(updatedRoot)
  }

  useEffect(() => {
    if (esitoAdv) {
      setRootComponent(esitoAdv)
    }
  }, [esitoAdv])
  const handleOpenModal = () => {

    setOpenModal(true);
    // In caso di pratica con riscio di tipo Medio e di azione con la seguente label selezionata,
    // bisogna invocare il metodo di closeAdvMRAndOpenAR
    const labelDaCercare = 'Sono emersi elementi tali da rendere necessaria una attività di adeguata verifica rafforzata';
    const labelDaCercareDue = 'E\' stata rilevata la presenza di un PIL- Politico Italiano Locale'
    const checkSelectedChild = (componente) => {
      if (componente.isSelected && (componente.label === labelDaCercare || componente.label === labelDaCercareDue)) {
        return true;
      }
      if (componente.children) {
        return componente.children.some(checkSelectedChild);
      }
      return false;
    };

    const isComponenteSelezionato = rootComponent.children.some(checkSelectedChild);
    setIsComponenteInalzaRischioSelezionato(isComponenteSelezionato);

  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleSalvaEsito = () => {

    setOpen(true)
    setLoading(true)
    setInfoMessage('Attendere....salvataggio in corso')
    saveEsitoAdv(rootComponent, idPratica).then(response => {
      setSaveRequired(false)
      setInfoMessage(response.data.message)
      setLoading(false)
      setError(false)
      setTimeout(function () {
        setOpen(false)
        setInfoMessage('')
      }, 3000)
    })
      .catch(error => {
        setLoading(false)
        setInfoMessage(error.response.data.message)
        setError(true)
        setTimeout(function () {
          setOpen(false)
          setInfoMessage('')
          setError(false)
        }, 3000)
      })
  }

  const handleChiusuraPratica = () => {
    // In caso di pratica con riscio di tipo Medio e di azione con la seguente label selezionata,
    // bisogna invocare il metodo di closeAdvMRAndOpenAR
    const labelDaCercare = 'Sono emersi elementi tali da rendere necessaria una attività di adeguata verifica rafforzata';
    const labelDaCercareDue = 'E\' stata rilevata la presenza di un PIL- Politico Italiano Locale'
    const checkSelectedChild = (componente) => {
      if (componente.isSelected && (componente.label === labelDaCercare || componente.label === labelDaCercareDue)) {
        return true;
      }
      if (componente.children) {
        return componente.children.some(checkSelectedChild);
      }
      return false;
    };

    const isComponenteSelezionato = rootComponent.children.some(checkSelectedChild);

    if (isComponenteSelezionato && (tipoInserimento === 'Automatica Medio Rischio' || tipoInserimento === 'Manuale Medio Rischio')) {
      setOpen(true)
      setLoading(true)
      setInfoMessage('Attendere...chiusura della pratica attuale in corso, e creazione di una nuova con livello di rischio aumentato.')
      closeAdvMr(idPratica)
        .then(response => {
          setSaveRequired(false)
          setInfoMessage(response.data.message)
          setLoading(false)
          setError(false)
          setTimeout(function () {
            setOpen(false)
            setInfoMessage('')
            handleReloadDettaglio()

          }, 3000)
        })
        .catch(error => {
          setLoading(false)
          setInfoMessage(error.response.data.message)
          setError(true)
          setTimeout(function () {
            setOpen(false)
            setInfoMessage('')
            setError(false)
          }, 3000)
        })
    } else {
      setOpen(true)
      setLoading(true)
      setInfoMessage('Attendere...modifica in corso')
      closePratica(idPratica).then(response => {
        setSaveRequired(false)
        setInfoMessage(response.data.message)
        setLoading(false)
        setError(false)
        setTimeout(function () {
          setOpen(false)
          setInfoMessage('')
          handleReloadDettaglio()

        }, 3000)
      })
        .catch(error => {
          setLoading(false)
          setInfoMessage(error.response.data.message)
          setError(true)
          setTimeout(function () {
            setOpen(false)
            setInfoMessage('')
            setError(false)
          }, 3000)
        })
    }
    handleCloseModal()

  }

  const handleShowSupporto = (rispostaSupporto) => {
    setRispostaSupporto(rispostaSupporto);
    setShowSupporto(prevState => !prevState)
  }

  if (!rootComponent) {
    return <div>Caricamento...</div>
  }

  return (
    <div>
      <CustomModal
        open={open}
        loading={loading}
        error={error}
        message={infoMessage}
      />
      <Accordion
        elevation={0}
        disableGutters square={true}
        expanded={expanded}
        onChange={() => setExpanded(prevState => !prevState)}
      >
        <AccordionSummary
          sx={{
            backgroundColor: theme.palette.yellow.middle,
            width: '100%',
          }}

          expandIcon={<ArrowDropDownIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          {rootComponent.label}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            backgroundColor: theme.palette.yellow.middle,
            width: '100%',
            alignItems: 'center',
          }}
        >
          {expanded && rootComponent.children && rootComponent.children.map((child, index) => (
            <RenderComponente
              key={index}
              componente={child}
              updateSelection={updateComponenteSelection}
              marginLevel={1}
              ndRequired={false}
              disable={disableChoice}
            />
          ))}
          {/*<DocOpzionali ></DocOpzionali>
*/}
          <AccordionActions sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            {listaStatiRichiestaSupportoSezionGialla.includes(statoPratica) &&
              assegnatario === JSON.parse(localStorage.getItem('user')) && (
                <StyledButton
                  onClick={() => handleShowSupporto(false)}
                  sx={{ borderRadius: '5px 0px 0px 0px', mt: 5 }}
                >
                  Richiesta Supporto
                </StyledButton>
              )}

            {(showButtonSupportoCons && (isValidUserInputMultipleFunctions(listaRuoliRispostaSupportoSezionGialla))) && (
              <StyledButton
                onClick={() => handleShowSupporto(true)}
                sx={{ borderRadius: '5px 0px 0px 0px', mt: 5 }}
              >
                Supporto consulenziale
              </StyledButton>
            )}

            <Box sx={{ flexGrow: 1 }} />
            {((showButton && (statoPratica === StatiPratica.IN_ATTESA_OPZIONALI.stato ||  statoPratica === StatiPratica.INFO_COMPLETE.stato || statoPratica === StatiPratica.CHECK_OUT_OPERATORE.stato)) && assegnatario === JSON.parse(localStorage.getItem('user'))) && (

              <StyledButton
                onClick={handleSalvaEsito}
                sx={{ borderRadius: '5px 0px 0px 0px', mt: 5 }}
                disabled={!saveRequired}
              >
                Salva
              </StyledButton>
            )}

            {(showButton && statoPratica === 'Info Complete' && assegnatario === JSON.parse(localStorage.getItem('user'))) && (
              <StyledButton
                disabled={!abilitaChiuso || saveRequired}
                onClick={handleOpenModal}
                sx={{ borderRadius: '5px 0px 0px 0px', mt: 5 }}
              >
                Chiuso
              </StyledButton>
            )}
            {(<Box sx={{ width: '30px', ml: 10 }} />)}
            <Dialog
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Conferma chiusura pratica"}</DialogTitle>
              <DialogContent>
                {(isComponenteInalzaRischioSelezionato && (tipoInserimento === 'Automatica Medio Rischio' || tipoInserimento === 'Manuale Medio Rischio'))
                  ? (<DialogContentText id="alert-dialog-description">
                    Sei sicuro di voler chiudere questa pratica? Confermando, l'attuale pratica verrà chiusa, e sarà aperta una nuova pratica con il livello di rischio aumentato. Questa azione non può essere annullata.
                  </DialogContentText>)
                  : (<DialogContentText id="alert-dialog-description">
                    Sei sicuro di voler chiudere questa pratica? Confermando, la pratica passerà nello stato "Da Approvare" e questa azione non può essere annullata.
                  </DialogContentText>)

                }

              </DialogContent>
              <DialogActions>
                <Button onClick={handleChiusuraPratica} color="primary" autoFocus>
                  Conferma
                </Button>
                <Button onClick={handleCloseModal} color="primary">
                  Annulla
                </Button>

              </DialogActions>
            </Dialog>
          </AccordionActions>

        </AccordionDetails>
      </Accordion>
      {(showSupporto &&
        (statoPratica === StatiPratica.IN_ATTESA_OPZIONALI.stato || statoPratica === StatiPratica.CHECK_OUT_OPERATORE.stato || statoPratica === StatiPratica.INFO_COMPLETE.stato || statoPratica === StatiPratica.DA_APPROVARE.stato)) &&
        <Supporto idPratica={idPratica}
          modalOpen={showSupporto}
          handleMod={handleShowSupporto}
          {...{ rispostaSupporto, assegnatario }}
        />
      }
    </div>
  )
}
